import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { getCategory } from "../api/getCategory";
import { useAuth } from "../../../lib/auth";
import ProductCard from "../../product/components/productCard";
import { getBillboard } from "../api/getBillboard";
import FeaturePage from "./FeaturePage";
import { ContactInfo } from "./Contactinfo";
import { Modal } from "antd";

export const MainPage = () => {
  const [categories, setCategories] = useState<any[]>([]); // Updated state to hold categories
  const { user } = useAuth(); // Use the useAuth hook to get the current user info
  const [isDialogVisible, setDialogVisible] = useState(false); // For showing the dialog
  const [billboardData, setBillboardData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  const handleBillboard = async () => {
    try {
      const response = await getBillboard();
      setBillboardData(response.data);
    } catch (error) {
      console.error("Error fetching billboard data:", error);
    }
  };

  const handleCategories = async () => {
    try {
      const response = await getCategory();
      if (response.data) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Set loading to true before fetching data
      await Promise.all([handleCategories(), handleBillboard()]); // Wait for both API calls to complete
      setIsLoading(false); // Set loading to false after data is fetched
    };

    fetchData();
  }, []);

  const handleDialogClose = () => {
    setDialogVisible(false);
  };

  const handleGoToSignUp = () => {
    setDialogVisible(false);
    navigate("/register"); // Navigate to the sign-up page
  };

  const handleQuantityChange = () => {
    if (!user) {
      setDialogVisible(true); // Show the dialog if the user is not logged in
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <div className="">
      <div className="m-4">
        <Carousel
          autoPlay={true}
          showThumbs={false}
          showStatus={false}
          showArrows={false}
        >
          {billboardData.length > 0
            ? billboardData.map((image: any, index: any) => (
                <div key={index} className="rounded-xl">
                  <img
                    src={image.image_path}
                    className="carousel-image rounded-xl h-48"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              ))
            : ""}
        </Carousel>
      </div>
      {/* Categories Section */}
      {categories && categories.length > 1 && (
        <div className="flex flex-wrap justify-start gap-4 m-6">
          {categories
            .filter((category) => category.is_active) // Filter only active categories
            .slice(0, 5) // Limit to 5 active categories
            .map((category) => (
              <div
                key={category.id}
                className="flex items-center justify-between w-48 h-20 bg-[#505050] text-white rounded-lg shadow-md p-2 cursor-pointer"
                onClick={() => navigate(`/home/${category.id}`)} // Navigate to the category page
              >
                <img src={category.image_file} className="w-16 h-16" />
                <span className="text-sm text-center flex-1">
                  {category.name_ar}
                </span>
              </div>
            ))}
        </div>
      )}
      {/* Grid Items for Each Category */}
      <div className="p-6 space-y-8">
        {categories.map((category) => {
          const activeProducts = category.products.filter(
            (product: any) => product.is_active
          );

          if (category.is_active && activeProducts.length > 0) {
            return (
              <div key={category.id}>
                {/* Section Header */}
                <div className="flex items-center mb-4 w-full justify-center">
                  <h2 className="text-3xl font-bold">{category.name_ar}</h2>
                </div>

                {/* Section Header */}
                <div className="flex items-center mb-4 w-full justify-center">
                  <h2 className="text-3xl font-bold">{category.label}</h2>
                </div>

                {/* Grid Items */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 m-6">
                  {activeProducts.map((product: any) => (
                    <ProductCard
                      categoryId={category.id}
                      key={product.id}
                      product={product}
                      onQuantityChange={handleQuantityChange}
                    />
                  ))}
                </div>

                {/* Button Below Each Category Section */}
                <div
                  className="flex justify-center my-8"
                  onClick={() => navigate(`/home/${category.id}`)}
                >
                  <button className="bg-gray-700 hover:bg-gray-800 text-white px-6 py-2 rounded-md">
                    عرض المزيد من المنتجات
                  </button>
                </div>
              </div>
            );
          } else {
            return category.is_active ? (
              <div key={category.id}>
                {/* Section Header */}
                <div className="flex items-center mb-4 w-full justify-center">
                  <h2 className="text-3xl font-bold">{category.name_ar}</h2>
                </div>

                {/* No Active Products Message */}
                <div className="flex justify-center w-full">
                  <div className="flex items-center justify-center w-full">
                    <p className="text-xl text-center text-gray-500 w-full">
                      لا توجد منتجات في هذه الفئة
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              ""
            );
          }
        })}
      </div>{" "}
      <hr className="border-gray-300 mb-4" />
      <FeaturePage onQuantityChange={handleQuantityChange} />
      {/* Sign-Up Dialog */}
      {/* Contact Info Section */}
      <ContactInfo />
      <Modal
        open={isDialogVisible}
        onCancel={handleDialogClose}
        footer={null}
        centered
      >
        <div className="bg-white p-6 rounded-lg w-full">
          <h3 className="text-xl mb-4 text-center">
            يجب عليك إنشاء حساب أولاً
          </h3>
          <div className="flex justify-center gap-4">
            <button
              onClick={handleGoToSignUp}
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md"
            >
              إنشاء حساب
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
